import styled from "styled-components";

const Content = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 300px;
`;

export default Content;

export const EditContent = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 0 0 1rem;
    padding: 0 0 0 0.5rem;
    border-left: 1px solid var(--border-color);

    width: 400px;

    height: 100%;
    min-height: calc(100vh - 80px);
    max-height: calc(100vh - 110px);

    position: sticky;
    right: 0;
    top: 8px;

    overflow-y: scroll;
    overflow-x: hidden;

    @media(max-width: 1200px){
        width: 300px;
        margin: 0 0 0 0.75rem;
    }
    @media(max-width: 900px){
        width: 250px;
        margin: 0 0 0 0.75rem;
        padding: 0 0 0 0.25rem;
    }
    @media(max-width: 800px){
        width: 200px;
        margin: 0 0 0 0.5rem;
        padding: 0 0 0 0.25rem;
    }
`;

export const DashboardContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: calc(100vh - 110px);
`;
